import { api } from "..";
import { SimpleSuccessResponse } from "./types";

export const deleteMessageForMe = async (
  chatId: number,
  messageId: number
): Promise<SimpleSuccessResponse> => {
  const res = await api.client.delete(
    `/chats/${chatId}/messages/${messageId}/me`
  );
  return res.data;
};

export const deleteMessageForEveryone = async (
  chatId: number,
  messageId: number
): Promise<SimpleSuccessResponse> => {
  const res = await api.client.delete(
    `/chats/${chatId}/messages/${messageId}/everyone`
  );
  return res.data;
};
